// import React, { useEffect, useState } from "react";
// import { useAuthState } from "react-firebase-hooks/auth";
// import { Link, useParams, useNavigate } from "react-router-dom";
// import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
// import auth from "../../firebase.init";
// import { Helmet } from "react-helmet";

// const PayNow = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [order, setOrder] = useState(null);
//   const [user] = useAuthState(auth);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [paypalSettings, setPaypalSettings] = useState(null);
//   const [settingsLoading, setSettingsLoading] = useState(true);

//   // ADD THIS: Processing flag to prevent double credits
//   const [isProcessing, setIsProcessing] = useState(false);

//   useEffect(() => {
//     setLoading(true);
//     fetch(`https://allyoutube01-2d46d9aff565.herokuapp.com/order/${id}`)
//       .then((res) => res.json())
//       .then((info) => {
//         setOrder(info);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error loading order:", err);
//         setError("Failed to load order details");
//         setLoading(false);
//       });

//     // Fetch PayPal settings
//     fetch(`https://allyoutube01-2d46d9aff565.herokuapp.com/api/paypal-settings`)
//       .then((res) => res.json())
//       .then((response) => {
//         if (response.success) {
//           setPaypalSettings(response.data);
//         } else {
//           console.error("Error in PayPal settings response:", response);
//           setError("Failed to load payment gateway settings");
//         }
//         setSettingsLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error loading PayPal settings:", err);
//         setError("Failed to load payment gateway settings");
//         setSettingsLoading(false);
//       });
//   }, [id]);

//   // Helper function to calculate membership validity date
//   const calculateMembershipValidity = (createdAt, validityDays) => {
//     const createdDate = new Date(createdAt);
//     return new Date(
//       createdDate.setDate(createdDate.getDate() + parseInt(validityDays))
//     ).toISOString();
//   };

//   const createOrder = (data, actions) => {
//     if (!order) {
//       console.error("Order data not available");
//       return;
//     }
//     console.log("Creating PayPal order with amount:", order.totalPrice);
//     return actions.order.create({
//       purchase_units: [
//         {
//           amount: {
//             value: order.totalPrice,
//             breakdown: {
//               item_total: {
//                 currency_code: paypalSettings.currency || "USD",
//                 value: order.packagePrice,
//               },
//               handling: {
//                 currency_code: paypalSettings.currency || "USD",
//                 value: order.processingFee,
//               },
//             },
//           },
//           description: order.packageName,
//           custom_id: order.orderId,
//           invoice_id: order.paymentId,
//         },
//       ],
//     });
//   };

//   // UPDATED: onApprove function with processing flag - SINGLE API CALL
//   const onApprove = async (data, actions) => {
//     // Prevent multiple processing
//     if (isProcessing) {
//       console.log("Payment already being processed...");
//       return;
//     }

//     setIsProcessing(true);

//     try {
//       const details = await actions.order.capture();
//       console.log("Payment completed", details);

//       // Calculate membership validity date
//       const membershipValidity = calculateMembershipValidity(
//         order.createdAt,
//         order.Validity
//       );

//       // SINGLE API CALL - Process everything at once
//       const response = await fetch(`https://allyoutube01-2d46d9aff565.herokuapp.com/process-payment-complete/${id}`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           paypalTransactionID:
//             details?.purchase_units[0]?.payments?.captures[0]?.id,
//           payerEmail: details.payer?.email_address,
//           captureTime:
//             details?.purchase_units[0]?.payments?.captures[0]?.create_time,
//           paymentId: order.paymentId,
//           orderId: order.orderId,
//           status: "Paid",
//           orderStatus: "Completed",
//           paymentMethod: "Paypal",
//           MembershipValidity: membershipValidity,
//           userEmail: order.customerEmail,
//           credit: order.credit,
//         }),
//       });

//       const result = await response.json();

//       if (!response.ok || !result.success) {
//         throw new Error(result.message || 'Payment processing failed');
//       }

//       if (result.alreadyProcessed) {
//         console.log("Payment already processed");
//       } else {
//         console.log("Payment processed successfully:", result);
//       }

//       // Show success message
//       setError(null);

//       // Redirect to success page after a short delay
//       setTimeout(() => {
//         navigate(`/user/subscription-history`);
//       }, 1000);

//     } catch (error) {
//       console.error("Payment processing failed:", error);
//       setError("Payment processing failed. Please contact support if the issue persists.");
//       setIsProcessing(false); // Reset processing flag on error
//     }
//   };

//   if (loading || settingsLoading) {
//     return (
//       <div className="d-flex flex-column align-items-center justify-content-center min-vh-50 py-5">
//         <div
//           className="spinner-border text-primary"
//           role="status"
//           style={{ width: "3rem", height: "3rem" }}
//         >
//           <span className="visually-hidden"></span>
//         </div>
//         <p className="mt-3 fw-medium text-primary">
//           Loading payment details...
//         </p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="container py-5 body-bg">
//         <div className="row justify-content-center">
//           <div className="col-md-8 col-lg-6">
//             <div className="alert alert-danger shadow-sm border-0 rounded-3 p-4">
//               <h4 className="alert-heading mb-3">
//                 <i className="bi bi-exclamation-triangle-fill me-2"></i>Error
//               </h4>
//               <p className="mb-3">{error}</p>
//               <button
//                 className="btn btn-primary px-4 py-2"
//                 onClick={() => navigate("/")}
//               >
//                 Return to Home
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!order || !paypalSettings) {
//     return (
//       <div className="container py-5">
//         <div className="row justify-content-center">
//           <div className="col-md-8 col-lg-6">
//             <div className="alert alert-warning shadow-sm border-0 rounded-3 p-4">
//               <h4 className="alert-heading mb-3">
//                 <i className="bi bi-question-circle-fill me-2"></i>Order Not
//                 Found
//               </h4>
//               <p className="mb-3">
//                 We couldn't find the order you're looking for. Please check the
//                 order ID and try again.
//               </p>
//               <button
//                 className="btn btn-primary px-4 py-2"
//                 onClick={() => navigate("/")}
//               >
//                 Return to Home
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Configure PayPal options based on API response
//   const paypalOptions = {
//     "client-id": paypalSettings.clientId,
//     currency: paypalSettings.currency,
//     intent: "capture",
//     components: "buttons",
//   };

//   // PayPal button styles from API settings
//   const buttonStyles = paypalSettings.buttonStyles || {
//     layout: "vertical",
//     color: "blue",
//     shape: "rect",
//     label: "pay",
//   };

//   // If PayPal is disabled in settings, show an appropriate message
//   if (!paypalSettings.enablePayPal) {
//     return (
//       <div className="d-flex justify-content-center align-items-center min-vh-100">
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-md-8 col-lg-6">
//               <div className="alert alert-info shadow-sm border-0 rounded-3 p-4">
//                 <h4 className="alert-heading mb-3">
//                   <i className="bi bi-info-circle-fill me-2"></i>Payment
//                   Unavailable
//                 </h4>
//                 <p className="mb-3">
//                   PayPal payments are currently unavailable. Please contact
//                   support for alternative payment methods.
//                 </p>
//                 <button
//                   className="btn btn-primary px-4 py-2"
//                   onClick={() => navigate("/")}
//                 >
//                   Return to Home
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Helmet>
//         <title>Pay Now | Complete Your Payment to Access Products</title>
//         <meta
//           name="description"
//           content="Complete your payment to unlock your purchased digital products. Secure payment options for a seamless transaction."
//         />
//       </Helmet>
//       <main>
//         {/* Breadcrumb Section */}
//         <section
//           className="position-relative py-4 py-md-5 bg-primary bg-gradient text-white"
//           style={{
//             background: "linear-gradient(135deg, #4a6bff 0%, #2541b8 100%)",
//             overflow: "hidden",
//           }}
//         >
//           <div
//             className="position-absolute top-0 end-0 opacity-10"
//             style={{
//               backgroundImage: "url(assets/img/breadcrumb-bg.svg)",
//               backgroundSize: "cover",
//               width: "100%",
//               height: "100%",
//               zIndex: "0",
//             }}
//           ></div>

//         </section>

//         {/* Payment Details Section */}
//         <section className="py-5 bg-light">
//           <div className="container">
//             <div className="row justify-content-center">
//               <div className="col-lg-10 col-xl-8">
//                 <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
//                   {/* Header */}
//                   <div className="card-header bg-white p-4 border-bottom border-light">
//                     <div className="d-flex justify-content-between align-items-center flex-wrap">
//                       <div>
//                         <h4 className="mb-1 fw-bold text-dark">
//                           {order.packageName || "Product"}
//                         </h4>
//                         <p className="text-muted mb-0">
//                           Order ID:{" "}
//                           <span className="fw-medium">{order.orderId}</span>
//                         </p>
//                       </div>
//                       <div className="text-end">
//                         <h3 className="mb-0 fw-bold text-primary">
//                           ${order.totalPrice} USD
//                         </h3>
//                         <span className="badge bg-success rounded-pill px-3 py-2 mt-2">
//                           {(order.paymentStatus || "Pending").toUpperCase()}
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Order Information */}
//                   <div className="card-body p-4">
//                     <div className="row g-4">
//                       {/* Customer Information */}
//                       <div className="col-md-6">
//                         <div className="p-3 bg-light rounded-3 h-100">
//                           <h5 className="mb-3 fw-semibold border-bottom pb-2 text-dark">
//                             Customer Information
//                           </h5>
//                           <div className="mb-2 d-flex">
//                             <span
//                               className="text-muted me-2"
//                               style={{ width: "100px" }}
//                             >
//                               Name:
//                             </span>
//                             <span className="fw-medium">
//                               {order.customerName}
//                             </span>
//                           </div>
//                           <div className="mb-2 d-flex">
//                             <span
//                               className="text-muted me-2"
//                               style={{ width: "100px" }}
//                             >
//                               Email:
//                             </span>
//                             <span className="fw-medium">
//                               {order.customerEmail}
//                             </span>
//                           </div>
//                           <div className="mb-2 d-flex">
//                             <span
//                               className="text-muted me-2"
//                               style={{ width: "100px" }}
//                             >
//                               Address:
//                             </span>
//                             <span className="fw-medium">
//                               {order.address || "Not specified"}
//                             </span>
//                           </div>
//                           <div className="mb-2 d-flex">
//                             <span
//                               className="text-muted me-2"
//                               style={{ width: "100px" }}
//                             >
//                               Country:
//                             </span>
//                             <span className="fw-medium">
//                               {order.country || "Not specified"}
//                             </span>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Order Details */}
//                       <div className="col-md-6">
//                         <div className="p-3 bg-light rounded-3 h-100">
//                           <h5 className="mb-3 fw-semibold border-bottom pb-2 text-dark">
//                             Order Details
//                           </h5>
//                           <div className="mb-2 d-flex justify-content-between">
//                             <span className="text-muted">Package Price:</span>
//                             <span className="fw-medium">
//                               ${order.packagePrice} USD
//                             </span>
//                           </div>
//                           {order.credit && (
//                             <div className="mb-2 d-flex justify-content-between">
//                               <span className="text-muted">Credits:</span>
//                               <span className="fw-medium">
//                                 {order.credit} credits
//                               </span>
//                             </div>
//                           )}
//                           <div className="pt-2 mt-2 border-top border-dashed d-flex justify-content-between">
//                             <span className="fw-semibold">Total:</span>
//                             <span className="fw-bold text-primary">
//                               ${order.totalPrice} USD
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Payment Section */}
//                     <div className="mt-4 pt-3 border-top">
//                       <h5 className="fw-bold mb-4 text-center">
//                         Complete Your Payment
//                       </h5>

//                       {/* Processing indicator */}
//                       {isProcessing && (
//                         <div className="alert alert-info mb-4 text-center">
//                           <div className="spinner-border spinner-border-sm me-2" role="status">
//                             <span className="visually-hidden"></span>
//                           </div>
//                           Processing your payment... Please wait.
//                         </div>
//                       )}

//                       {error && (
//                         <div className="alert alert-danger mb-4">
//                           <i className="bi bi-exclamation-triangle-fill me-2"></i>
//                           {error}
//                         </div>
//                       )}

//                       <div className="row justify-content-center">
//                         <div className="col-md-8">
//                           <div className="card shadow-sm border-0 mb-4">
//                             <div className="card-body p-4">
//                               <PayPalScriptProvider options={paypalOptions}>
//                                 <PayPalButtons
//                                   createOrder={createOrder}
//                                   onApprove={onApprove}
//                                   style={buttonStyles}
//                                   disabled={isProcessing} // Disable buttons during processing
//                                   onError={(err) => {
//                                     console.error("PayPal error:", err);
//                                     setError(
//                                       "There was an error with PayPal. Please try again."
//                                     );
//                                     setIsProcessing(false);
//                                   }}
//                                 />
//                               </PayPalScriptProvider>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Footer */}
//                   <div className="card-footer bg-white p-4 text-center border-top border-light">
//                     <p className="mb-0">
//                       Need help? Contact our{" "}
//                       <Link to="/contact" className="text-decoration-none">
//                         Support Team
//                       </Link>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </main>
//     </>
//   );
// };

// export default PayNow;

import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, useParams, useNavigate } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import auth from "../../firebase.init";
import { Helmet } from "react-helmet";

const PayNow = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [user] = useAuthState(auth);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paypalSettings, setPaypalSettings] = useState(null);
  const [settingsLoading, setSettingsLoading] = useState(true);

  // Processing flag to prevent double credits
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`https://allyoutube01-2d46d9aff565.herokuapp.com/order/${id}`)
      .then((res) => res.json())
      .then((info) => {
        setOrder(info);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading order:", err);
        setError("Failed to load order details");
        setLoading(false);
      });

    // Fetch PayPal settings
    fetch(`https://allyoutube01-2d46d9aff565.herokuapp.com/api/paypal-settings`)
      .then((res) => res.json())
      .then((response) => {
        if (response.success) {
          setPaypalSettings(response.data);
        } else {
          console.error("Error in PayPal settings response:", response);
          setError("Failed to load payment gateway settings");
        }
        setSettingsLoading(false);
      })
      .catch((err) => {
        console.error("Error loading PayPal settings:", err);
        setError("Failed to load payment gateway settings");
        setSettingsLoading(false);
      });
  }, [id]);

  // Helper function to calculate membership validity date
  const calculateMembershipValidity = (createdAt, validityDays) => {
    const createdDate = new Date(createdAt);
    return new Date(
      createdDate.setDate(createdDate.getDate() + parseInt(validityDays)),
    ).toISOString();
  };

  const createOrder = (data, actions) => {
    if (!order) {
      console.error("Order data not available");
      return;
    }
    console.log("Creating PayPal order with amount:", order.totalPrice);
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: order.totalPrice,
            breakdown: {
              item_total: {
                currency_code: paypalSettings.currency || "USD",
                value: order.packagePrice,
              },
              handling: {
                currency_code: paypalSettings.currency || "USD",
                value: order.processingFee,
              },
            },
          },
          description: order.packageName,
          custom_id: order.orderId,
          invoice_id: order.paymentId,
        },
      ],
    });
  };

  // onApprove function with processing flag - SINGLE API CALL
  const onApprove = async (data, actions) => {
    // Prevent multiple processing
    if (isProcessing) {
      console.log("Payment already being processed...");
      return;
    }

    setIsProcessing(true);

    try {
      const details = await actions.order.capture();
      console.log("Payment completed", details);

      // Calculate membership validity date
      const membershipValidity = calculateMembershipValidity(
        order.createdAt,
        order.Validity,
      );

      // SINGLE API CALL - Process everything at once
      const response = await fetch(
        `https://allyoutube01-2d46d9aff565.herokuapp.com/process-payment-complete/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            paypalTransactionID:
              details?.purchase_units[0]?.payments?.captures[0]?.id,
            payerEmail: details.payer?.email_address,
            captureTime:
              details?.purchase_units[0]?.payments?.captures[0]?.create_time,
            paymentId: order.paymentId,
            orderId: order.orderId,
            status: "Paid",
            orderStatus: "Completed",
            paymentMethod: "Paypal",
            MembershipValidity: membershipValidity,
            userEmail: order.customerEmail,
            credit: order.credit,
          }),
        },
      );

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || "Payment processing failed");
      }

      if (result.alreadyProcessed) {
        console.log("Payment already processed");
      } else {
        console.log("Payment processed successfully:", result);
      }

      // Show success message
      setError(null);

      // Redirect to success page after a short delay
      setTimeout(() => {
        navigate(`/thank-you/${id}`);
      }, 1000);
    } catch (error) {
      console.error("Payment processing failed:", error);
      setError(
        "Payment processing failed. Please contact support if the issue persists.",
      );
      setIsProcessing(false); // Reset processing flag on error
    }
  };

  if (loading || settingsLoading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 fw-medium text-secondary">
          Loading payment details...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-vh-100 d-flex align-items-center bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="alert alert-danger shadow-sm border-0 rounded-3 p-4 text-center">
                <div className="mb-3 text-danger">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="currentColor"
                    className="bi bi-exclamation-triangle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                  </svg>
                </div>
                <h4 className="alert-heading mb-2">Error</h4>
                <p className="mb-4 text-secondary">{error}</p>
                <button
                  className="btn btn-primary px-4 py-2"
                  onClick={() => navigate("/")}
                >
                  Return to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!order || !paypalSettings) {
    return (
      <div className="min-vh-100 d-flex align-items-center bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="alert alert-warning shadow-sm border-0 rounded-3 p-4 text-center">
                <h4 className="alert-heading mb-3">Order Not Found</h4>
                <p className="mb-4 text-secondary">
                  We couldn't find the order you're looking for. Please check
                  the order ID and try again.
                </p>
                <button
                  className="btn btn-primary px-4 py-2"
                  onClick={() => navigate("/")}
                >
                  Return to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Configure PayPal options based on API response
  const paypalOptions = {
    "client-id": paypalSettings.clientId,
    currency: paypalSettings.currency,
    intent: "capture",
    components: "buttons",
  };

  // PayPal button styles from API settings
  const buttonStyles = paypalSettings.buttonStyles || {
    layout: "vertical",
    color: "blue",
    shape: "rect",
    label: "pay",
  };

  // If PayPal is disabled in settings, show an appropriate message
  if (!paypalSettings.enablePayPal) {
    return (
      <div className="min-vh-100 d-flex align-items-center bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="alert alert-info shadow-sm border-0 rounded-3 p-4 text-center">
                <h4 className="alert-heading mb-3">Payment Unavailable</h4>
                <p className="mb-4 text-secondary">
                  PayPal payments are currently unavailable. Please contact
                  support for alternative payment methods.
                </p>
                <button
                  className="btn btn-primary px-4 py-2"
                  onClick={() => navigate("/")}
                >
                  Return to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-light  mt-5">
      <Helmet>
        <title>Pay Now | Complete Your Payment</title>
        <meta
          name="description"
          content="Complete your payment securely to access your products."
        />
        {/* Bootstrap Icons */}
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
        />
      </Helmet>

      {/* Header Section */}
      <div className="bg-primary py-5 mt-5">
        <div className="container text-center text-white">
          <h1 className="fw-bold mb-2 mt-5"></h1>
          <p className="mb-0 opacity-75">
            Complete your purchase to unlock your package
          </p>
        </div>
      </div>

      <main className="container py-5" style={{ marginTop: "-2rem" }}>
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-8">
            <div className="card shadow border-0 rounded-3 overflow-hidden bg-white">
              {/* Card Header */}
              <div className="card-header bg-white p-4 border-bottom">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                  <div className="mb-3 mb-md-0">
                    <h4 className="mb-1 fw-bold text-dark">
                      {order.packageName || "Product"}
                    </h4>
                    <p className="text-secondary mb-0">
                      Order ID:{" "}
                      <span className="fw-medium text-dark">
                        {order.orderId}
                      </span>
                    </p>
                  </div>
                  <div className="text-md-end">
                    <h3 className="mb-0 fw-bold text-primary">
                      ${order.totalPrice}{" "}
                      <span className="fs-6 text-muted">USD</span>
                    </h3>
                    <div className="mt-2">
                      <span className="badge bg-warning text-dark px-3 py-2 rounded-pill">
                        {(order.paymentStatus || "Pending").toUpperCase()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card Body */}
              <div className="card-body p-4">
                <div className="row g-4">
                  {/* Customer Info */}
                  <div className="col-md-6">
                    <div className="p-3 bg-light rounded-3 h-100 border">
                      <h6 className="text-uppercase text-secondary fw-bold small mb-3 border-bottom pb-2">
                        Customer Information
                      </h6>
                      <div className="mb-2">
                        <small className="text-secondary d-block">Name</small>
                        <span className="fw-medium text-dark">
                          {order.customerName}
                        </span>
                      </div>
                      <div className="mb-2">
                        <small className="text-secondary d-block">Email</small>
                        <span className="fw-medium text-dark">
                          {order.customerEmail}
                        </span>
                      </div>
                      <div className="mb-2">
                        <small className="text-secondary d-block">
                          Address
                        </small>
                        <span className="fw-medium text-dark">
                          {order.address || "N/A"}
                        </span>
                      </div>
                      <div>
                        <small className="text-secondary d-block">
                          Country
                        </small>
                        <span className="fw-medium text-dark">
                          {order.country || "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Order Details */}
                  <div className="col-md-6">
                    <div className="p-3 bg-light rounded-3 h-100 border">
                      <h6 className="text-uppercase text-secondary fw-bold small mb-3 border-bottom pb-2">
                        Payment Summary
                      </h6>
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-secondary">Package Price</span>
                        <span className="fw-medium text-dark">
                          ${order.packagePrice}
                        </span>
                      </div>

                      {order.credit && (
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-secondary">
                            Credits Included
                          </span>
                          <span className="fw-medium text-dark">
                            {order.credit}
                          </span>
                        </div>
                      )}

                      <hr className="my-3 text-secondary" />

                      <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-bold text-dark">Total Amount</span>
                        <span className="fw-bold text-primary fs-5">
                          ${order.totalPrice}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* PayPal Section */}
                <div className="mt-5">
                  <div className="text-center mb-4">
                    <h5 className="fw-bold text-dark">Select Payment Method</h5>
                    <p className="text-secondary small">
                      <i className="bi bi-lock-fill me-1"></i>
                      Encrypted and secure connection
                    </p>
                  </div>

                  {/* Processing Alert */}
                  {isProcessing && (
                    <div className="alert alert-info text-center mb-4">
                      <div
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></div>
                      Processing your payment. Please do not close this window.
                    </div>
                  )}

                  {/* Error Alert */}
                  {error && (
                    <div className="alert alert-danger mb-4">
                      <i className="bi bi-exclamation-triangle-fill me-2"></i>
                      {error}
                    </div>
                  )}

                  <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6">
                      <div className="p-3 rounded-3 bg-white">
                        <PayPalScriptProvider options={paypalOptions}>
                          <PayPalButtons
                            createOrder={createOrder}
                            onApprove={onApprove}
                            style={buttonStyles}
                            disabled={isProcessing}
                            onError={(err) => {
                              console.error("PayPal error:", err);
                              setError(
                                "There was an error connecting to PayPal. Please try again.",
                              );
                              setIsProcessing(false);
                            }}
                          />
                        </PayPalScriptProvider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card Footer */}
              <div className="card-footer bg-light p-3 text-center border-top">
                <small className="text-secondary"></small>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PayNow;
